var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"reset-password"}},[_c('SACSetPassword',{attrs:{"infoText":"Create new password","buttonLabel":"Reset Password","processing":_vm.processing,"createPassword":_vm.createPassword,"error":_vm.error,"success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }